import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { Comunicado } from './comunicado';

@Injectable()
export class ComunicadoService {

  private headers = new Headers({'Accept': 'application/json; text/plain, */*'});
  private documentoUrl = URL_API + '/comunicacaooutros';

  getComunicados(): Promise<Comunicado[]> {
    return this.http.get(this.documentoUrl)
                .toPromise()
                .then(response => response.json() as Comunicado[])
                .catch(this.handleError);
  }

  constructor(
    private http: Http
  ) { }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/comunicado/comunicado.service.ts